module.exports = __webpack_public_path__ + "static/secretSquirrel-6191d6855ce61afa1b5d121b6b41827e.png";